<template>
  <!-- modal -->
  <div class="dimed">
    <div class="layer">
      <!-- header -->
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.QrCode.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.QrCode.msg2') }}</div>
      </div>
      <!-- //header -->

      <!-- body -->
      <div class="layer__body">
        <div class="menu__event" v-if="isSimpleToken === true">
          <!-- one item -->
          <!-- 체크되면 아래 요소에 on 클래스 추가, span.ico-checked 요소 추가 -->
          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY19') >= 0" @mouseup="onQrCodePay('PAY19')">
            <div>
              <img src="@/assets/images/user/logo-qr-alipay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg7') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY20') >= 0" @mouseup="onQrCodePay('PAY20')">
            <div>
              <img src="@/assets/images/user/logo-qr-we-chat-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg8') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY74') >= 0" @mouseup="onQrCodePay('PAY74')">
            <div>
              <img src="@/assets/images/user/logo-qr-pay-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg9') }}</span>
            </div>
          </div>
          <!-- //one item -->

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY78') >= 0" @mouseup="onQrCodePay('PAY78')">
            <div>
              <img src="@/assets/images/user/logo-qr-m-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg3') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY75') >= 0" @mouseup="onQrCodePay('PAY75')">
            <div>
              <img src="@/assets/images/user/logo-qr-line-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg10') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY76') >= 0" @mouseup="onQrCodePay('PAY76')">
            <div>
              <img src="@/assets/images/user/logo-qr-r-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg4') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY79') >= 0" @mouseup="onQrCodePay('PAY79')">
            <div>
              <img src="@/assets/images/user/logo-qr-aw-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg11') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY77') >= 0" @mouseup="onQrCodePay('PAY77')">
            <div>
              <img src="@/assets/images/user/logo-qr-d-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg5') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY64') >= 0" @mouseup="onQrCodePay('PAY64')">
            <div>
              <img src="@/assets/images/user/logo-qr-quo-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg12') }}</span>
            </div>
          </div>
          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY80') >= 0" @mouseup="onQrCodePay('PAY80')">
            <div>
              <img src="@/assets/images/user/logo-qr-yuchopay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg13') }}</span>
            </div>
          </div>
        </div>

        <div class="menu__event" v-else>
          <!-- one item -->
          <!-- 체크되면 아래 요소에 on 클래스 추가, span.ico-checked 요소 추가 -->
          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY22') >= 0" @mouseup="onQrCodePay('PAY22')">
            <div>
              <img src="@/assets/images/user/logo-qr-npay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg14') }}</span>
            </div>
          </div>
          <!-- //one item -->

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY17') >= 0" @mouseup="onQrCodePay('PAY17')">
            <div>
              <img src="@/assets/images/user/logo-qr-kakaopay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg15') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY14') >= 0" @mouseup="onQrCodePay('PAY14')">
            <div>
              <img src="@/assets/images/user/logo-qr-ssgpay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg16') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY18') >= 0" @mouseup="onQrCodePay('PAY18')">
            <div>
              <img src="@/assets/images/user/logo-qr-smile-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg17') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY16') >= 0" @mouseup="onQrCodePay('PAY16')">
            <div>
              <img src="@/assets/images/user/logo-qr-zero-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg18') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY24') >= 0" @mouseup="onQrCodePay('PAY24')">
            <div>
              <img src="@/assets/images/user/logo-qr-lpay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg19') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY19') >= 0" @mouseup="onQrCodePay('PAY19')">
            <div>
              <img src="@/assets/images/user/logo-qr-alipay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg7') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY20') >= 0" @mouseup="onQrCodePay('PAY20')">
            <div>
              <img src="@/assets/images/user/logo-qr-we-chat-pay.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg8') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY15') >= 0" @mouseup="onQrCodePay('PAY15')">
            <div>
              <img src="@/assets/images/user/logo-qr-payco.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg20') }}</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY23') >= 0" @mouseup="onQrCodePay('PAY23')">
            <div>
              <img src="@/assets/images/user/logo-qr-appcard.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">{{ $t('Modal.QrCode.msg21') }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- //body -->

      <div class="layer__button">
        <button @mouseup="closeQrCode()" class="btn btn--line btn--xlg btn-anim">{{ $t('Modal.QrCode.msg6') }}</button>
      </div>
    </div>
    <!-- //modal -->
    <QrCodePay
      @setPayComplete="setPayComplete"
      @paymentError="
        paymentError;
        qrCodePayYn = false;
      "
      @closeQrCodePay="qrCodePayYn = false"
      :tran="tranParam"
      :totalUprc="totalUprc"
      v-if="qrCodePayYn == true"
    />
  </div>
</template>
<script>
import qrCodePay from '@/components/modal/payment/QrCodePay.vue';

export default {
  name: 'qrCode',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      qrCodePayYn: false,
      tranNo: '',
      tranParam: this.tran,
      isSimpleToken: this.$store.getters.getIsSimpleToken,
      //결제 방법 종류
      supportPayments: this.$store.getters.getPosConfig.posConfig.supportPayments,
    };
  },
  mounted() {},
  props: {
    totalUprc: Number,
    tran: Object,
  },
  methods: {
    setPayComplete(tranObj) {
      this.qrCodePayYn = false;
      this.$emit('setPayComplete', tranObj);
    },
    paymentError() {
      this.$emit('paymentError');
      this.qrCodePayYn = false;
    },
    onQrCodePay(paymethod) {
      this.$logInfo(`Select QrCode QR Num : ${paymethod}`);

      this.tranParam.PAYMENTLIST[0].SETTLE_METHOD = paymethod;
      this.qrCodePayYn = true;
    },
    closeQrCode() {
      this.$logInfo(`QrCode Close Payment`);
      this.$store.dispatch('startIdle');
      this.$emit('closeQrCode');
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  components: {
    QrCodePay: qrCodePay,
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/menu-dark.css" scoped></style>
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped>
.row__txt {
  width: 100%;
}

.logo__img {
  width: auto;
  height: auto;
}

.touchbox.touchbox--port img {
  width: auto;
  margin-bottom: 0.7em;
}

.touchbox {
  padding: 0.4em var(--txt-pd20) 0.8em;
}
</style>
